module.exports = __webpack_public_path__ + "img/sparkle-table.34ae81b9.svg";